var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.475 2.75098H0.3C0.125 2.75098 0 2.87598 0 3.05098V19.701C0 19.876 0.125 20.001 0.3 20.001H12.475C12.65 20.001 12.775 19.876 12.775 19.701V3.05098C12.775 2.87598 12.65 2.75098 12.475 2.75098ZM12.175 19.401H0.6V3.35098H12.175V19.401Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1996 0H3.02461C2.84961 0 2.72461 0.125 2.72461 0.3V1.825C2.72461 2 2.84961 2.125 3.02461 2.125C3.19961 2.125 3.32461 2 3.32461 1.825V0.625H14.8996V16.65H13.6996C13.5246 16.65 13.3996 16.775 13.3996 16.95C13.3996 17.125 13.5246 17.25 13.6996 17.25H15.2246C15.3996 17.25 15.5246 17.125 15.5246 16.95V0.3C15.4996 0.125 15.3746 0 15.1996 0Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopy);
export default __webpack_public_path__ + "static/media/ic_copy.a0227afb38d380f213c98a0c31e7be22.svg";
export { ForwardRef as ReactComponent };